import React from "react";
import {PosOrderSummary} from "@/data/entities/order";
import OrderListItem from "@widgets/pos/orders/sidebar/list/OrderListItem";
import {useNavigate} from "react-router-dom";
import {posOrders} from "@/routing/Router";
import {Button, EmptyState, Icon} from "peggirkit";
import {FormattedMessage} from "react-intl";
import {FunnelIcon, ShoppingCartIcon} from "@heroicons/react/20/solid";
import {RemoveFilterFn} from "@widgets/pos/orders/sidebar/ordersSidebar";

type Props = {
    selectedPublicCartId: string | undefined,
    filteredOrders: PosOrderSummary[],
    hasActiveFilter: boolean,
    removeFilterFn: RemoveFilterFn,
};

const OrdersList = ({selectedPublicCartId, filteredOrders, hasActiveFilter, removeFilterFn}: Props) => {
    const navigate = useNavigate();

    if (filteredOrders.length === 0) {
        return (
            <EmptyState
                containerClassname={"p-6"}
                icon={<Icon icon={ShoppingCartIcon}/>}
                title={<FormattedMessage id={hasActiveFilter ? "noResults" : "noOrdersYet"}/>}
                description={
                    <FormattedMessage
                        id={hasActiveFilter ? "noFilteredOrdersResults" : "noOrdersYetDescription"}
                    />
                }
                action={
                    hasActiveFilter
                        ? <Button
                            variant={"outline"}
                            color={"secondary"}
                            iconBefore={<Icon icon={FunnelIcon}/>}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: () => removeFilterFn(),
                                },
                            }}
                        >
                            <FormattedMessage id={"removeFilter"}/>
                        </Button>
                        : undefined
                }
            />
        );
    }

    return (
        <ol className={"flex-1 min-h-0 overflow-y-auto p-3 space-y-2 bg-gray-50 dark:bg-slate-900"}>
            {filteredOrders.map((order: PosOrderSummary) =>
                <li key={order.cartPublicId}>
                    <OrderListItem
                        order={order}
                        selected={order.cartPublicId === selectedPublicCartId}
                        onSelect={() => navigate(posOrders(order.cartPublicId).absolutePath())}
                    />
                </li>
            )}
        </ol>
    );
};

export default OrdersList;